import type { TopBarAction } from '../contexts/TopBarContext';

export const MAX_INLINE_TOP_BAR_ACTIONS = 3;

export function splitTopBarActions(actions: readonly TopBarAction[]): {
  inline: readonly TopBarAction[];
  overflow: readonly TopBarAction[];
} {
  return {
    inline: actions.slice(0, MAX_INLINE_TOP_BAR_ACTIONS),
    overflow: actions.slice(MAX_INLINE_TOP_BAR_ACTIONS),
  };
}